module.exports = __webpack_public_path__ + "img/LBZ Bungalows.abf12e34.jpg";